import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base"
import { getESGReqHeader } from "./tool-service";

// 查詢系統功能清單
export const queryFeFunctionsList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010101'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010101")}`, method: 'post', data: ReqBody })
}

// 查詢系統功能明細
export const queryFeFunctionsInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010102")}`, method: 'post', data: ReqBody })
}

// 系統功能更新 before
export const B2010103Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010103",true)}`, method: 'post', data: ReqBody })
}

// 系統功能更新
export const updateFeFunctionsInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010103")}`, method: 'post', data: ReqBody })
}

// 查詢系統功能授權角色
export const queryFuncRoleMappingInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010104")}`, method: 'post', data: ReqBody })
}

// 編輯角色授權功能清單
export const updateFuncRoleMappingInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010105'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010105")}`, method: 'post', data: ReqBody })
}

